import { applicationActions } from "../reducer";

export const resetActiveModals = () => applicationActions.setActiveModals(null);
